import React from 'react'

const Spinner = () => {
    return (
        <div className="text-center my-3">
            <div className="spinner-border" role="status">
                {/* <span class="sr-only">Loading...</span> */}
            </div>
        </div>
    )
}

export default Spinner
